module.exports = __webpack_public_path__ + "static/media/ky.612fc51b.svg";